import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { apiPost, useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import AuthLayout from '../components/AuthLayout';

/** Step 2: the e-mailed link opens this page. The reset only happens on the button click (a POST),
 *  so mail scanners that pre-open links can't use it up. */
export default function ResetPasswordPage() {
  const { formatApiErrorDetail } = useAuth();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [done, setDone] = useState('');
  const [error, setError] = useState(token ? '' : 'This link is incomplete. Request a new one from the sign-in page.');
  const [loading, setLoading] = useState(false);

  const confirm = async () => {
    setError('');
    setLoading(true);
    try {
      const { data } = await apiPost('/auth/reset-password', { token });
      setDone(data.message);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Reset your password" subtitle="Confirm to receive a new password by e-mail" testId="reset-password-page">
      {done ? (
        <div role="status" className="p-4 bg-brand/10 border border-brand/30 rounded-lg text-ink text-sm" data-testid="reset-done">{done}</div>
      ) : (
        <>
          {error && <div role="alert" className="mb-4 p-3 bg-danger/10 border border-danger/30 rounded-lg text-danger text-sm" data-testid="reset-error">{error}</div>}
          {token && (
            <Button onClick={confirm} disabled={loading} data-testid="reset-confirm" className="w-full h-11 bg-brand hover:bg-brand-soft text-white font-medium rounded-lg">
              {loading ? 'Resetting…' : 'Send me a new password'}
            </Button>
          )}
        </>
      )}
      <p className="mt-6 text-center text-sm text-ink-2">
        <Link to="/login" className="text-brand hover:text-brand-soft font-medium underline-offset-4 hover:underline">Back to sign in</Link>
        {error && <> · <Link to="/forgot-password" className="text-brand hover:text-brand-soft font-medium underline-offset-4 hover:underline">Request a new link</Link></>}
      </p>
    </AuthLayout>
  );
}
